export default __webpack_public_path__ + "static/media/goods_pettern_left.99a4b721.jpg";